module.exports = __webpack_public_path__ + "static/img/tree.59ecebc1.svg";